module.exports = {"__schema":{"types":[{"possibleTypes":[{"name":"OpenHoursEventInstance"},{"name":"AfterHoursEventInstance"}],"name":"CalendarEventInstance","kind":"UNION"},{"possibleTypes":[{"name":"Customer"},{"name":"CustomCustomer"},{"name":"StoreCustomer"}],"name":"CustomerUnion","kind":"UNION"}]}}


//////////////////
// WEBPACK FOOTER
// ./src/setup/ApolloConnector/cache/fragmentTypes.json
// module id = 1768
// module chunks = 2